import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  status: 'initial',
  rooms: undefined,
  fetch: {
    status: 'initial'
  }
}

const Room = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Room;



// WEBPACK FOOTER //
// ./src/store/modules/room/store.js